export class PartnerOrganizationOwnershipManagerImpl {
    partnerOrganizationFetcher;
    constructor(partnerOrganizationFetcher) {
        this.partnerOrganizationFetcher = partnerOrganizationFetcher;
    }
    async transferWorkspaceOwnership(workspaceId, dto) {
        return this.partnerOrganizationFetcher.post(['workspaces', workspaceId, 'transfer-ownership'], {
            body: dto,
        });
    }
    async transferPartnerOrganizationOwnership(dto) {
        return this.partnerOrganizationFetcher.post(['transfer-ownership'], {
            body: dto,
        });
    }
}
